export const navigation = {
  philosophy: "理念",
  services: "服务",
  training: "培训",
  credentials: "资质",
  clientele: "客户",
  approach: "方法",
  contact: "联系"
};

export const hero = {
  title: "精英医疗安全",
  subtitle: "专为高净值人士",
  description: "为全球超高净值家庭、私人庄园、豪华游艇和专属企业环境提供无与伦比的紧急医疗培训和响应服务。",
  cta: "安排咨询"
};

export const philosophy = {
  title: "我们的理念",
  subtitle: "卓越无妥协",
  description: "我们相信医疗紧急情况需要立即的专业干预。我们的理念专注于提供最高水准的医疗培训和紧急响应服务，专门为要求完美的挑剔客户量身定制。"
};

export const services = {
  title: "核心服务",
  subtitle: "全面医疗解决方案",
  cpr_title: "高级心肺复苏/自动体外除颤器培训",
  cpr_description: "专为家庭工作人员、游艇船员和安保人员设计的专业认证课程。",
  emergency_title: "紧急响应",
  emergency_description: "24/7快速响应医疗服务，配备精英急救医疗团队。",
  consultation_title: "医疗咨询",
  consultation_description: "针对高风险环境和活动的专业医疗咨询服务。"
};

export const footer = {
  copyright: "© 2024 U First Doctors. 版权所有。",
  phone: "电话",
  email: "邮箱",
  address: "地址"
};